export const colorIcon = '#D3D3D3';
export const colorFilledIcon = '#F98140';
